/**
 * Application Configuration
 *
 * Centralized configuration for the React application.
 * Reads from environment variables with fallback defaults.
 */

const config = {
  // API Base URL - reads from Vite environment variable
  // Vite exposes env vars that start with VITE_ to the client
  apiBaseUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000',

  // Application environment
  environment: import.meta.env.MODE || 'development',

  // Check if in production
  isProd: import.meta.env.PROD,

  // Check if in development
  isDev: import.meta.env.DEV,
}

// Log configuration on load (only in development)
if (config.isDev) {
  console.log('App Configuration:', config)
}

export default config
